import type { ReactNode } from 'react'
import styles from './QuestionsTab.module.css'

export interface QuestionsTabProps {
  toolbox: ReactNode
  /**
   * The questions' cards.
   */
  children?: ReactNode
  inspector?: ReactNode
  testId?: string
}

/**
 * The Questions tab: the toolbox, the scrolling canvas of questions, and the
 * inspector.
 */
export function QuestionsTab({
  toolbox,
  children,
  inspector,
  testId,
}: QuestionsTabProps) {
  return (
    <div className={styles.root}>
      {toolbox}
      <div className={styles.canvas} data-test={testId && `${testId}-canvas`}>
        <div className={styles.column}>{children}</div>
      </div>
      {inspector}
    </div>
  )
}
